import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "infos"
}
const _hoisted_8 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (!_ctx.multiple)
    ? (_openBlock(), _createBlock(_component_Select, {
        key: 0,
        onFilter: _ctx.searchTipping,
        modelValue: _ctx.modelValue,
        filter: "",
        filterFields: ['name','id'],
        invalid: _ctx.invalid,
        options: _ctx.courses,
        "onUpdate:modelValue": _ctx.emitValue,
        showClear: !_ctx.isNull(_ctx.modelValue)
      }, {
        value: _withCtx((slotProps) => [
          (slotProps.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.getName(slotProps.value)), 1))
            : _createCommentVNode("", true)
        ]),
        option: _withCtx((slotProps) => [
          _createElementVNode("div", null, _toDisplayString(_ctx.getName(slotProps.option)), 1)
        ]),
        emptyfilter: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "pi pi-spin pi-spinner loader" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("admin_components.course_select.empty")), 1)
              ]))
        ]),
        empty: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "pi pi-spin pi-spinner loader" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("admin_components.course_select.empty")), 1)
              ]))
        ]),
        _: 1
      }, 8, ["onFilter", "modelValue", "invalid", "options", "onUpdate:modelValue", "showClear"]))
    : (_openBlock(), _createBlock(_component_MultiSelect, {
        key: 1,
        ref: "multiselect",
        onFilter: _ctx.searchTipping,
        modelValue: _ctx.modelValue,
        filter: "",
        filterFields: ['name','id'],
        invalid: _ctx.invalid,
        options: _ctx.courses,
        "onUpdate:modelValue": _ctx.emitValue,
        dataKey: 'id'
      }, {
        value: _withCtx((slotProps) => [
          (slotProps.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(slotProps.value.length == 1 ? _ctx.getName(slotProps.value[0]) : slotProps.value.length + ' ' + _ctx.$t('admin_components.course_select.course_selected')), 1))
            : _createCommentVNode("", true)
        ]),
        option: _withCtx((slotProps) => [
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(slotProps.option.name) + " - " + _toDisplayString(_ctx.getDayOfWeek(slotProps.option.day)) + " " + _toDisplayString(slotProps.option.startHour) + " ", 1),
            (slotProps.option.galaShows && slotProps.option.galaShows.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.option.galaShows, (galaShow) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: galaShow['@id']
                    }, _toDisplayString(galaShow.name) + " - " + _toDisplayString(galaShow.date), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        emptyfilter: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "pi pi-spin pi-spinner loader" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("admin_components.course_select.empty")), 1)
              ]))
        ]),
        empty: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "pi pi-spin pi-spinner loader" }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("admin_components.course_select.empty")), 1)
              ]))
        ]),
        _: 1
      }, 8, ["onFilter", "modelValue", "invalid", "options", "onUpdate:modelValue"]))
}